const piAfEventReaderHu = {
	piAfEventReaderEditForm: 'PI AF eseményolvasó',
	piAfEventReaderTable: 'PI AF eseményolvasó',
	name: 'Név',
	piConnection: 'PI kapcsolat',
	'piConnection.name': 'PI kapcsolat',
	database: 'Adatbázis',
	templateName: 'Sablon neve',
	start_date_time: 'Kezdődátum',
	end_date_time: 'Végdátum'
};

export default piAfEventReaderHu;
